import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { KeycloakService } from '../../../../../authentication/keycloak.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { DocumentReference, DocumentService } from 'src/app/documents/documents.service';
import { saveAs } from 'file-saver';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MaterialPdfViewerPopUpComponent } from 'src/app/shared/components/material-pdf-viewer-pop-up/material-pdf-viewer-pop-up.component';
import { CrewContract } from 'src/app/generated/services/transportation/crew/crew';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { MaterialPgIconButtonComponent } from 'src/app/shared/components/material-pg-iconbutton/material-pg-icon-button.component';

@Component({
  selector: 'app-crew-contract',
  templateUrl: './crew-contract.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialPdfViewerPopUpComponent,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MaterialPgInputComponent,
    MaterialPgInputComponent,
    MaterialOrganisationSelectorComponent,
    MaterialChunkFileUploadComponent,
    MatAccordion,
    MatExpansionModule,
    MaterialPgButtonComponent,
    MaterialPgIconButtonComponent
  ]
})
export class CrewContractComponent implements OnInit {

  crewContract = CrewContract.create();
  managements: Organisation[] = [];
  selectedManagement = Organisation.create();
  _title!: string;
  showContract!: boolean;
  doc?:DocumentReference;

  get selectedCrewContract() {
    return this.crewContract;
  }
  @Input() set selectedCrewContract(value: CrewContract) {
    if (value) {
      this.crewContract = value;
    }
  }

  @Input() set title(value: string) {
    if (value) {
      this._title = value;
    }
  }

  @Output() saveCrewContract: EventEmitter<CrewContract> = new EventEmitter<CrewContract>();

  constructor(private _keycloakService: KeycloakService,
    private _organisationService: OrganisationService,
    private _documentService: DocumentService) { }

  hasRole(roleName: string) {
    return this._keycloakService.hasRole(roleName);
  }

  ngOnInit() {
    this._organisationService.get().subscribe(organisations => {
      this.managements = organisations.filter(
        (x) => x.properties['technical'] === true
      );
      if (this.crewContract && this.crewContract.managementOrganisationId) {
        this.selectedManagement = this.managements.find(x => x.name === this.crewContract.managementOrganisationId) || Organisation.create();
      }
    });
  }

  saveContract() {
    this.crewContract.managementOrganisationId = this.selectedManagement.name;
    this.saveCrewContract.emit(this.crewContract);
  }

  saveContractExtension(event:any, i:number) {
    this.crewContract.extensions[i] = event;
    this.saveContract();
  }

  downLoadDocumnet(id:string) {
    this._documentService.download(id).subscribe(f => {
      saveAs(f.body, `${id}.pdf`);
    });
  }

}
